<template>
  <h2 class="text-2xl text-slate-800 font-bold mb-6">{{ title }}</h2>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

